import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from 'react-router-dom';

import Error from './component/Error';
import PAN from './component/PAN';
import Body from './component/Body';
import Home from './component/Home';
import PAN360 from './component/PAN360';
import BasicPAN from './component/BasicPAN';
import Aadhaar360 from './component/Aadhaar360';
import Introduction from './component/Introduction';
import PriceUpdates from './component/PriceUpdates';
import NewTemplate from './component/NewTemplate';
import ActivateTemplate from './component/ActivateTemplate';
import ManageTemplate from './component/ManageTemplate';
import ManageSMS from './component/ManageSMS';
import WhatsAppManager from './component/WhatsappManager';
import PriceChart from './component/PriceChart';
import Templates from './component/Templates';
import Campaign from './component/Campaign';
import Contacts from './component/Contacts';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Provider } from 'react-redux';
import store from './redux/store';

const roleReceived = localStorage.getItem('roleReceived') || 'Admin';

const roleSpecificRoutes = {
  Admin: [
    { path: 'pan', element: <PAN /> },
    { path: 'aadhaar360', element: <Aadhaar360 /> },
    { path: 'newtemplate', element: <NewTemplate /> },
    { path: 'managesms', element: <ManageSMS /> },
    { path: 'managetemplate', element: <ManageTemplate /> },
    { path: 'activatetemplate', element: <ActivateTemplate /> },
    { path: 'pricechart', element: <PriceChart /> },
    { path: 'templates', element: <Templates /> },
    { path: 'campaign', element: <Campaign /> },
    { path: 'contacts', element: <Contacts /> },
  ],
  User: [
    { path: 'pan', element: <PAN /> },
    { path: 'aadhaar360', element: <Aadhaar360 /> },
    { path: 'pricechart', element: <PriceChart /> },
  ],
  ContentManager: [
    { path: 'whatsappmanager', element: <WhatsAppManager /> },
    { path: 'newtemplate', element: <NewTemplate /> },
    // { path: 'managesms', element: <ManageSMS /> },
    { path: 'managetemplate', element: <ManageTemplate /> },
    { path: 'activatetemplate', element: <ActivateTemplate /> },
    { path: 'pricechart', element: <PriceChart /> },
    { path: 'templates', element: <Templates /> },
    { path: 'campaign', element: <Campaign /> },
    { path: 'contacts', element: <Contacts /> },
  ],
};

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <Error />,
    children: [
      { path: '', element: <Home /> },
      { path: 'body', element: <Body /> },
      { path: 'introduction', element: <Introduction /> },
      { path: 'pan360', element: <PAN360 /> },
      { path: 'basicpan', element: <BasicPAN /> },
      { path: 'priceupdates', element: <PriceUpdates /> },
      ...(roleSpecificRoutes[roleReceived] || []),
    ],
  },
]);

ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_AUTH_FOR_REACT}>
      <RouterProvider router={router} />
    </GoogleOAuthProvider>
  </Provider>
);

reportWebVitals();